<p [innerHtml]="'funnel.footer.conditions' | translate"></p>
<p [innerHTML]="'funnel.footer.warning.text' | translate"></p>
<p>
  <a (click)="showCookieSettings()" class="svnl-cookie-click" translate="funnel.footer.cookies.link"></a>
  <span [innerHTML]="'funnel.footer.cookies.text' | translate"></span>
</p>
<hr class="svnl-hr">
<p [innerHTML]="'funnel.footer.contact' | translate"></p>
